import { h } from 'preact';

import { useCallback, useRef } from 'preact/hooks';
import { GlobalState } from '../../states/global-state';
import { useSignal, useSignalEffect } from '@preact/signals';
import Visibility from '../visibility';
import type { ModalConfig } from '../../types/types';

const CustomModal = props => {
  const showed = useSignal(false);
  const title = useSignal('');
  const text = useSignal('');
  const showPositiveBtn = useSignal(true);
  const showNegativeBtn = useSignal(true);
  const modalInstance = useRef(null);
  const modalInstanceConfig = useRef<ModalConfig>({} as ModalConfig);
  useSignalEffect(() => {
    const isShow = GlobalState.showModal.value;
    const modal = GlobalState.modal.value;
    const modalConfig = modal[0] as ModalConfig;
    modalInstanceConfig.current = modalConfig as ModalConfig;

    title.value = modalConfig.title;
    text.value = modalConfig.text || modalConfig.message;

    // console.log(isShow);
    // console.log(modalConfig);

    showed.value = isShow;

    if (isShow) {
      const MicroModal = window['MicroModal'];

      modalInstance.current = MicroModal;
      showPositiveBtn.value =
        modalConfig.showPositiveBtn == undefined
          ? true
          : modalConfig.showPositiveBtn;
      showNegativeBtn.value =
        modalConfig.showNegativeBtn == undefined
          ? true
          : modalConfig.showNegativeBtn;

      MicroModal.init({
        awaitCloseAnimation: true,
      });
      setTimeout(() => {
        MicroModal.show('modal-1');
      }, 1000);
    }
  });

  const positiveHandler = useCallback(() => {
    modalInstanceConfig.current.positiveCallback &&
      modalInstanceConfig.current.positiveCallback(null);
    modalInstance.current && modalInstance.current.close();
  }, []);

  const negativeHandler = useCallback(() => {
    modalInstanceConfig.current.negativeCallback &&
      modalInstanceConfig.current.negativeCallback(null);
    modalInstance.current && modalInstance.current.close();
  }, []);

  return (
    <Visibility condition={showed}>
      <div
        class="modal micromodal-slide"
        id="modal-1"
        tabIndex={-1}
        data-micromodal-close
      >
        <div class="modal__overlay" tabIndex={-1} data-micromodal-close>
          <div class="modal-dialog modal__container">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">{title}</h5>
                <button
                  type="button"
                  class="btn-close"
                  onClick={negativeHandler}
                  aria-label="Close"
                />
              </div>
              <div class="modal-body">
                <p dangerouslySetInnerHTML={{ __html: text.value }} />
              </div>
              <div class="modal-footer">
                <Visibility condition={showPositiveBtn}>
                  <button
                    type="button"
                    class="btn btn-success"
                    onClick={positiveHandler}
                  >
                    Submit
                  </button>
                </Visibility>
                &nbsp; &nbsp;
                <Visibility condition={showNegativeBtn}>
                  <button
                    type="button"
                    class="btn btn-outline-secondary"
                    // data-micromodal-close
                    aria-label="Close this dialog window"
                    onClick={negativeHandler}
                  >
                    Close
                  </button>
                </Visibility>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Visibility>
  );
};

export default CustomModal;
